import { Coordinate, Question, Size } from '@/types/slide';
import { useMemo } from 'react';
import { Stage, Layer, Line } from 'react-konva';

type Dot = {
    anchorPosition: Coordinate[];
    color: string;
};

const isDot = (dot: unknown): dot is Dot => {
    return typeof dot === 'object' && dot !== null && 'anchorPosition' in dot && Array.isArray((dot as Dot).anchorPosition) && 'color' in dot && typeof (dot as Dot).color === 'string';
};

const normaliseCoordinate = (size: Size, coordinate: Coordinate): Coordinate => {
    return {
        x: (coordinate.x + size.width) / 2,
        y: ((coordinate.y - size.height) * -1) / 2,
    };
};

export const ResultDisplayDrawing = ({ question }: { question: Question }) => {
    const data = useMemo(() => (question.answers[0]?.data ? JSON.parse(question.answers[0]?.data) : null), [question]);
    const lines = useMemo(() => {
        const dots: Dot[] = [];
        for (const dot of data?.drawing?.dots || []) {
            if (!isDot(dot)) {
                continue;
            }

            dots.push({
                anchorPosition: dot.anchorPosition.map((coord) => normaliseCoordinate(question.size, coord)),
                color: dot.color,
            });
        }

        return dots;
    }, [data, question.size]);

    return (
        <Stage width={question.size.width} height={question.size.height}>
            <Layer>
                {lines.map((line, index) => (
                    <Line key={index} points={line.anchorPosition.flatMap((coord) => [coord.x, coord.y])} stroke={`#${line.color}`} strokeWidth={2} fill='transparent' />
                ))}
            </Layer>
        </Stage>
    );
};
